import React, { useMemo } from 'react'
import { useWindowScroll } from 'react-use'

import useMediaQuery from '@/hooks/useMediaQuery'

import { Container, Flex } from '../common/Box'
import ConnectWallet from '../ConnectWallet'
// import Language from '../Language'
import GlobalPriorityFee from '../settings/GlobalPriorityFee'
import GlobalSettings from '../settings/GlobalSettings'

// import ThemeChange from '../ThemeChange'
import Contacts from './Contacts'
import LogoWithName from './LogoWithName'
import MenuDrawer from './MenuDrawer'
import Navs from './Navs'

const Header: React.FC = () => {
  const { gtXL } = useMediaQuery()

  const { y } = useWindowScroll()

  const blur = useMemo(() => {
    if (y >= 200) return 8
    return (y / 200) * 8
  }, [y])

  return (
    <header
      style={{ backdropFilter: `blur(${blur}px)` }}
      className="header fixed top-0 z-10 w-full"
    >
      <Container className="max-w-none !py-0">
        <Flex className="relative h-[50px] items-center justify-between xl:h-[72px] xl:justify-center">
          {gtXL ? (
            <>
              <Flex className="absolute left-0 items-center gap-2">
                <LogoWithName />
                <Contacts />
              </Flex>
              <Navs />
            </>
          ) : (
            <MenuDrawer />
          )}
          <Flex className="right-0 gap-1 xl:absolute">
            <Flex>
              <GlobalPriorityFee
                wrapperClassName="pr-0 rounded-r-none"
                className="rounded-r-none"
              />
              <GlobalSettings
                wrapperClassName="rounded-l-none"
                className="rounded-l-none"
              />
            </Flex>
            {/* <Language /> */}
            {/* <ThemeChange /> */}
            <ConnectWallet />
          </Flex>
        </Flex>
      </Container>
    </header>
  )
}

export default Header
